import { render, staticRenderFns } from "./numbers-buy-table-cell-action.vue?vue&type=template&id=01035850&"
import script from "./numbers-buy-table-cell-action.vue?vue&type=script&lang=js&"
export * from "./numbers-buy-table-cell-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports